import { Dialog, DialogActions, DialogContent, FormControl, Grid, InputLabel, MenuItem, Select } from "@material-ui/core"
import AppBarModal from "../../general/AppBarModal"
import React, { useEffect, useState } from 'react'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import { BtnForm } from "../../general/BotonesAccion"
import DateFnsUtils from '@date-io/date-fns';
import { consulta, obtenerValoresFiltros } from "../../../global/js/funciones"
import moment from "moment"
import { act } from "react"
import TareasTerminadas from "../../general/TareasTerminadas"
import emma_w from '../../../global/imagenes/emma_w.png';

export const ModalArchivoTextoPlano = (props) => {
    let {
        open,
        onClose,
        actualizarMensaje
    } = props

    const [data_estadistica, setData_estadistica] = useState({});
    const [tipo, setTipo] = useState(0);
    const [inicio, setInicio] = useState(moment().format('YYYY-MM-DD'));
    const [final, setFinal] = useState(moment().format('YYYY-MM-DD'));
    const [cod_prestador, setCod_prestador] = useState('');
    const [cargando, setCargando] = useState(false);

    // useEffect(async () => {
    //     let cod_prestador = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Cod_Pres' }]);
    //     setCod_prestador(cod_prestador[0].nombre);
    // }, [])

    useEffect(() => {
        let mounted = true;
        async function loadCodPrestador() {
            try {
                const cod_prestador = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Cod_Pres' }]);
                if (mounted && Array.isArray(cod_prestador) && cod_prestador[0]) {
                    setCod_prestador(cod_prestador[0].nombre);
                }
            } catch (err) {
                console.error(err);
            }
        }
        loadCodPrestador();
        return () => { mounted = false; };
    }, []);
    

    const obtenerEstadisticas = () => {
        return new Promise(resolve => {
            consulta(`api/v1.0/portal/estadistica`, data_estadistica, "post", (error, estado, resp) => {
                resolve(estado === 200 && !error ? resp.lista : resp.titulo);
            })
        })
    }

    const getEstadistica = (tipo) => {
        let data_estadistica =
        {
            tipo,
            date_inicio: moment(inicio).format('YYYY-MM-DD'),
            date_final: moment(final).format('YYYY-MM-DD')
        }
        setData_estadistica(data_estadistica);
    }

    const download = (data) => {

        let nombre_archivo = validar_nombre_archivo(tipo);

        if (data.length > 0) {

            let keys = Object.keys(data[0]);

            let text = "";

            data.forEach(element => {
                let aux = []
                keys.forEach(key => aux.push(element[key]))
                text += aux.join("|$$|")+"\n"
            });

            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
            if (tipo == 3) element.setAttribute('download', `${cod_prestador}${moment().format('YYYYMMDD')}.txt`);
                else if (tipo == 4) element.setAttribute('download', `PL${data[data.length - 1].Codigo_prestador}${moment().format('YYYYMMDD')}.txt`);
                else element.setAttribute('download', `${nombre_archivo}-${moment().format('YYYY-MM-DD, h:mm a')}.txt`);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        }
    }

    const validar_nombre_archivo = (tipo) => { 
        let nombre_archivo = "";
        switch (tipo) {
            case 1:
                nombre_archivo = "Registro_Estudiantes_Graduados";
                break;
            case 2:
                nombre_archivo = "Registro_Empresas";
                break;
            case 3:
                nombre_archivo = "Registro_Vacantes_Laborales";
                break;
            case 4:
                nombre_archivo = "Registro_Vacantes_Practicas";
                break;
            case 5:
                nombre_archivo = "Numero_Remisiones";
                break;
            case 6:
                nombre_archivo = "PQRS";
                break;
            default:
                break;
        }
        return nombre_archivo;
    }

    const onChange = (e) => {
        setTipo(e?.target?.value);
        getEstadistica(e?.target?.value);
    }

    const handleChange = (setter) => (e) => {
        setter(e);
        getEstadistica(tipo);
    }

    const onSubmit = async () => {
        setCargando(true);
        if (Object.keys(data_estadistica).length > 2 && data_estadistica.tipo != 0) download(await obtenerEstadisticas());
        else actualizarMensaje({ titulo: 'Seleccione Algún filtro', tipo: 'info', mostrar: true, tiempo: 6000 });
        setCargando(false);
    }

  return (
    <>
        <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
            <AppBarModal titulo={'Archivos texto plano'} mostrarModal={onClose} titulo_accion="" />
                <DialogContent style={{ padding: 0 }}>
                    {cargando ? <TareasTerminadas mensaje='Cargando...' marginTop='7%' imagen={emma_w} widthImg="10%" cargando={true} /> :
                    <>
                    <Grid container direction={'row'} justifyContent={'center'} style={{ paddingTop: 40 }} >
                        <Grid item xs={12} sm={12} md={10} lg={8}>
                            <Grid container direction={'row'} justifyContent={'center'}>
                                <Grid item xs={5}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            id='inicio'
                                            required
                                            label="Fecha Inicial"
                                            name='inicio'
                                            format='dd/MM/yyyy'
                                            value={inicio}
                                            onChange={(e) => handleChange(setInicio)(e)}
                                            fullWidth
                                            KeyboardButtonProps={{ 'aria-label': 'cambiar fecha' }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={5}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            id='date_final'
                                            required
                                            label="Fecha Final"
                                            name='date_final'
                                            format='dd/MM/yyyy'
                                            value={final}
                                            onChange={(e) => handleChange(setFinal)(e)}
                                            fullWidth
                                            KeyboardButtonProps={{ 'aria-label': 'cambiar fecha' }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                            </Grid>
                            <Grid container direction={'row'} justifyContent={'center'} style={{ paddingTop: 20 }}>
                                <Grid item xs={10}>
                                    <FormControl className='form-control'>
                                        <InputLabel required>Seleccione el reporte a exportar</InputLabel>
                                        <Select onChange={onChange} value={tipo}>
                                            <MenuItem value={1}>Registro Estudiantes/Graduados</MenuItem>
                                            <MenuItem value={2}>Registro Empresas</MenuItem>
                                            <MenuItem value={3}>Registro Vacantes Laborales</MenuItem>
                                            <MenuItem value={4}>Registro Vacantes Practicas</MenuItem>
                                            <MenuItem value={5}>Número de Remisiones</MenuItem>
                                            <MenuItem value={6}>PQRS</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>  
                        </Grid>
                    </Grid>
                    </>
                    }
                </DialogContent>
                <DialogActions>
                    <BtnForm texto="CERRAR" callback={onClose} />
                    <BtnForm texto="GENERAR" callback={onSubmit} />
                </DialogActions>
        </Dialog>
    </>
  )
}